module.exports = __webpack_public_path__ + "img/acacia_mweya33.0ee8e4b7.jpeg";